import { Component, OnInit, Input } from '@angular/core';
import { ProductService } from 'src/app/core/services/product.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-category-modern',
  templateUrl: './category-modern.component.html',
  styleUrls: ['./category-modern.component.css']
})
export class CategoryModernComponent implements OnInit {

  @Input()
  category:any;

  public productList: any[];
  public urlHost = "";
  public loading: boolean = true;
  col1:any[];
  col2:any[];
  constructor(
    private productService: ProductService,
    private router: ActivatedRoute
  ) {
    this.urlHost = environment.urlHostImage;
  }

  ngOnInit() {
    this.getProductList(this.category.codCategoria);
  }

  getProductList(codCategoria) {
    this.loading = true;
    this.productService.getProductList(codCategoria).subscribe(
      (data) => {
        this.productList = data;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  getValidate(product:any):boolean{
    return this.productService.getValidate(product);
  }

  /*fillColumns(){
    this.col1=new Array();
    this.col2=new Array();
    if(this.productList && this.productList.length>0){
      this.productList.forEach(element => {
        if(this.col1.length<2){
          this.col1.push(element);
        }else{
          if(this.col2.length<2){
            this.col2.push(element);
          }
        }
      });
    }
  }*/
}
